import StorageHandler from './StorageHandler';
export default StorageHandler;
